import { Extension } from '@tiptap/core';
import type { Awareness } from 'y-protocols/awareness';
import { defaultSelectionBuilder, yCursorPlugin } from '@tiptap/y-tiptap';

type CollaborationCursorUser = {
  name: string | null;
  color: string | null;
};

type CollaborationCursorProvider = {
  awareness: Awareness;
};

const defaultRender = (user: CollaborationCursorUser) => {
  const cursor = document.createElement('span');
  cursor.classList.add('collaboration-cursor__caret');
  cursor.setAttribute('style', `border-color: ${user.color}`);

  const label = document.createElement('div');
  label.classList.add('collaboration-cursor__label');
  label.setAttribute('style', `background-color: ${user.color}`);
  label.insertBefore(document.createTextNode(user.name || ''), null);

  cursor.insertBefore(label, null);
  return cursor;
};

export const CollaborationCursor = Extension.create({
  name: 'collaborationCursor',
  priority: 999,

  addOptions() {
    return {
      provider: null as CollaborationCursorProvider | null,
      user: {
        name: null,
        color: null,
      } as CollaborationCursorUser,
      render: defaultRender,
      selectionRender: defaultSelectionBuilder,
    };
  },

  onCreate() {
    if (!this.options.provider) {
      throw new Error('The "provider" option is required for the CollaborationCursor extension');
    }
  },

  addProseMirrorPlugins() {
    const awareness = this.options.provider?.awareness;
    if (!awareness) {
      return [];
    }

    awareness.setLocalStateField('user', this.options.user);

    return [
      yCursorPlugin(awareness, {
        cursorBuilder: this.options.render,
        selectionBuilder: this.options.selectionRender,
      }),
    ];
  },
});
